// @ts-nocheck
import * as React from 'react';
import Firma from './Firma';
import { ModalGeneral } from '../../../Componentes/ModalGeneral';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import EditNoteIcon from '@mui/icons-material/EditNote';

export function FirmaButton() {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <Tooltip title="Editar Firmas">
                <Fab
                    sx={{
                        zIndex: 1,
                        backgroundColor: "#B71234",
                        '&:hover': { backgroundColor: "#C5415C" },
                    }}
                    onClick={() => setOpen(true)}
                >
                    <EditNoteIcon sx={{ color: '#fff', fontSize: 28 }} />
                </Fab>
            </Tooltip>
            <ModalGeneral
                Contenido={<Firma onClose={() => setOpen(false)} />}
                open={open}
                onClose={() => setOpen(false)}
                titulo="Firmas"
            />
        </>
    );
}
